import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { limparPopupsLiberados } from "../tour_guiado/utils/popups_liberados.js";

const CLASSE_TOUR_ATIVO = 'driver-active'
const SELETORES_RESIDUO_DE_TOUR = '.driver-overlay, .driver-popover, #driver-dummy-element'
const CLASSES_BODY_DO_TOUR = [CLASSE_TOUR_ATIVO, 'driver-fade', 'driver-simple']
const CLASSES_DO_ALVO = ['driver-active-element', 'driver-no-interaction']
const SELETORES_ALVO_MARCADO = CLASSES_DO_ALVO.map((classe) => `.${classe}`).join(', ')
const ATRIBUTOS_ARIA_DO_ALVO = ['aria-haspopup', 'aria-expanded', 'aria-controls']

function limparNosDeTour() {
  const residuos = document.querySelectorAll(SELETORES_RESIDUO_DE_TOUR)

  residuos.forEach((no) => no.remove())
  document.body.classList.remove(...CLASSES_BODY_DO_TOUR)
  limparPopupsLiberados()
  document.querySelectorAll(SELETORES_ALVO_MARCADO).forEach((alvo) => {
    alvo.classList.remove(...CLASSES_DO_ALVO)
    ATRIBUTOS_ARIA_DO_ALVO.forEach((atributo) => alvo.removeAttribute(atributo))
  })

  return residuos.length > 0
}

export function removerResiduoDeTour() {
  if (document.body.classList.contains(CLASSE_TOUR_ATIVO)) return false
  return limparNosDeTour()
}

class Driver {
  DEFAULT_OPTIONS = {
    doneBtnText: window.t("interface.driver_js.finalizar"),
    closeBtnText: window.t("interface.driver_js.fechar"),
    nextBtnText: window.t("interface.driver_js.proximo"),
    prevBtnText: window.t("interface.driver_js.voltar"),
    popoverClass: 'maino-tour-popover',
    progressText: `{{current}} de {{total}}`,
    onDestroyStarted: () => {
      if (!this.driverInstance.hasNextStep() || confirm(window.t("interface.driver_js.sair_do_tour"))) {
        this.driverInstance.destroy();
      }
    },
  }

  constructor(options = {}) {
    this.driverInstance = driver();
    this.options = { ...this.DEFAULT_OPTIONS, ...options };
  }

  tour(steps, startAt = 0) {
    const optionsTour = {
      showProgress: true,
    }
    this.driverInstance.setConfig({...this.options, ...optionsTour});
    limparNosDeTour();
    this.driverInstance.setSteps(steps);

    this.driverInstance.drive(startAt);
  }

  focusHighlight(element) {
    this.driverInstance.highlight(element);
  }
}

export default Driver;
